// extracted by mini-css-extract-plugin
module.exports = {"body":"CollapsibleWidget-module__body___2VoDq","header":"CollapsibleWidget-module__header___24xT1","widget":"CollapsibleWidget-module__widget___3Vo7G"};